module.exports = __webpack_public_path__ + "img/dirty.be5030ca.webp";